import Page from './Page'
import getStyles from './getStyles'

export default Page
export {
  getStyles,
}
